import { environment } from '../environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/toPromise';
import * as $ from 'jquery';

@Injectable()
export class AppService<TModel> {

  constructor(private http: HttpClient) { }

  get headers(): HttpHeaders {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    headers.append('Access-Control-Allow-Credentials', '*');
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Access-Control-Allow-Methods', 'GET, POST, PATCH, PUT, DELETE, OPTIONS');
    headers.append('Access-Control-Allow-Headers', 'Origin, X-Requested-With, X-XSRF-TOKEN, Content-Type, Accept, X-Auth-Token');
    return headers;
  }

  private methodUrl(method: string): string {
      return `${environment.meepServerUrl}/api/${method}`;
  }
  protected async getAllAsync(methodName: string) {
    const url = this.methodUrl(methodName);
    const result = await this.http.get(url, { headers: this.headers }).toPromise();

    return result;
  }
  protected async getAsync(methodName: string) {
    const url = this.methodUrl(methodName);
    const result = await this.http.get(url, { headers: this.headers }).toPromise();

    return result;
  }
  protected async postAsync(methodName: string, model?: any) {
    const url = this.methodUrl(methodName);
    let result;
    if (model) {
      result = await this.http.post(url, JSON.stringify(model), { headers: this.headers }).toPromise();
    } else {
      result = await this.http.post(url, { headers: this.headers }).toPromise();
    }
    return result;
  }
  protected async putAsync(methodName: string, model?: any) {
    const url = this.methodUrl(methodName);
    const result = await this.http.put( url, JSON.stringify(model), { headers: this.headers }).toPromise();
    return result;
  }
  protected async putAllAsync(methodName: string, model: any = null) {
    const url = this.methodUrl(methodName);
    const result = await this.http.put(url, JSON.stringify(model), { headers: this.headers }).toPromise();
    return result;
  }
  protected async deleteAsync(methodName: string) {
    const url = this.methodUrl(methodName);
    const result = await this.http.delete(url, { headers: this.headers }).toPromise();
    return result;
  }
  protected async signInAsync(model: any): Promise<TModel> {
    const result = await this.http.post<TModel>( `${environment.meepServerUrl}/token`, model,
    { headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded') }).toPromise();
    return result;
  }
  protected async findImageInBlob(url: any) {
    return new Promise(function (resolve, reject) {
      $.ajax({
        url: url,
        dataType: 'text',
        method: 'GET',
        success: () => {
          resolve();
        },
        error: () => {
          reject();
        }
      });
  });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/app.service.ts